import { PagingResultsViewModel } from "../../../core/_infrastructure/types/common";


export class EnvioAduanasV3ItemResultsViewModel extends PagingResultsViewModel {

    public ResultList: EnvioAduanasV3ItemViewModel[];
}

export class EnvioAduanasV3ItemViewModel {
    public Id: number;
    public IdSolicitud: number;
    public FechaInicio: Date;
    public FechaEnvio: Date;
    public FechaCompleta: string = '';
    public FechaInicioCompleta: string = '';
    public Duracionms: number;
    public CodigoSolicitud: string = '';
    public Funcion: string = '';
    public IdEstadoEnvioAduanas: number;
    public EstadoEnvioAduanas: string = '';
    public DescripcionError: string = '';
    public Respuesta: string = '';
    public SoapRequest: string = '';
    public SoapResponse: string = '';
}

export class EnvioAduanasV3ViewModel {

    firstDayMonth: Date;
    lastDayMonth: Date;

    constructor() {

        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        let temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - (0.001 * 60 * 60 * 24));

        this.FechaDesde = this.firstDayMonth;
        this.FechaHasta = this.lastDayMonth;
    }

    public Id: number;
    public IdSolicitud: number = 0;
    public IdEstadoEnvioAduanas: number = 0;
    public CodigoSolicitud: string = '';
    public Funcion: string = '';
    public FechaDesde: Date | null ;
    public FechaHasta: Date | null;
}








